import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from "antd";
import Utils from "../../../../commons/utils/utils";
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";
import Loading from "../../../../commons/components/loading";
import CardContainer from "../../../../commons/components/cardContainer";
import UserIcon from "../../../../commons/icons/userIcon";
import AccountToggle from "../../../../commons/components/AccountToggle";
import AvatarIcon from "../../../../commons/icons/avatarIcon";
import ButtonBack from "../../../../commons/components/buttonBack"
import { ErrorText, CardTitle, PermissionContainer, CardContent } from './cardUserStyles';

function CardUser(props) {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.userLogin.userData.id);
    const { selectedPartner, selectedUser } = useSelector((state) => state.accessManagement);

    const [permissions] = useState([]);
    const { screens } = useSelector(state => state.userLogin);

    const [userData, setUserData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorRoleSelect, setErrorRoleSelect] = useState("");
    
    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/gestao-acessos") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    useEffect(() => {
        getUserInformation(selectedUser, selectedPartner);
    }, [selectedUser, selectedPartner]);

    useEffect(() => {
        getRoleData(userData.application_roles);
    }, [userData]);

    function getUserInformation(selectedUser, selectedPartner) {
        Http.get(`/users/management-access-user-info?user_id=${selectedUser.id}&partner_id=${selectedPartner.partner_id}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setUserData(responseData.data);
                    setLoading(false);
                }
            }).catch(err => {
                setUserData([]);
                setLoading(false);
            })
    }

    function getRoleData(userApplicationRoles) {
        if(userApplicationRoles) {
            Http.get(`/roles/roles-and-applications`, Http.headers)
                .then(response => {
                    const responseData = response.data
                    if (!responseData.response.error) {
                        let applicationRoles = [];

                        let result = Utils.isDevPartner(selectedPartner) ? Utils.filterDataToDevPartner(responseData.data) : responseData.data;

                        result.map((dataItem) => {
                            if (dataItem.access_management == true) {
                                let userApplicationRole = userApplicationRoles.filter((ap_role) => ap_role.application_name === dataItem.name)[0];

                                let application = { title: dataItem.name, key: dataItem.id, id: dataItem.id };
                                let roles = [];
                                dataItem.roles.map((dataRole) => {
                                    let role = { title: dataRole.name, key: dataItem.id + '-' +dataRole.id,
                                                id: dataRole.id, checked: userApplicationRole?.roles.includes(dataRole.name) }
                                    roles.push(role);
                                })
                                application.children = roles;
                                applicationRoles.push(application);
                            }
                        })

                        setRoleData(applicationRoles)
                    }
                }).catch(err => {
                    setRoleData([]);
                })
        }
    }

    function newRoleDataCustom(application_id, role_id, active) {
        let newRoleData = [];
        roleData.forEach(entry => {
            newRoleData.push(entry);
            if(entry.id == application_id) {
                entry.children.forEach(role => {
                    if(role.id == role_id){
                        role.checked = active;
                    }
                })
            }
        });

        setRoleData(newRoleData);
    }

    const renderLoading = () => (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
            <Loading width={50} height={50} />
        </div>
    );

    const renderPage = () => (
        <>
            {renderUserInformation()}
            {renderProfile()}
            {renderPermissions()}
            { userData.devices ? renderDevices() : null}
        </>
    )

    const renderUserInformation = () => (
        <CardContainer style={{ minWidth: 450 }}>
            <CardContent>
                <Row align={"middle"} wrap={false}>
                    <Col span={1} style={{ marginRight: 64 }}>
                        <div>
                            {renderPicture()}
                        </div>
                    </Col>
                    <Col span={4} style={{ marginRight: 24 }}>
                        <p>
                            <span style={{ color: '#626E82' }}>Nome</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold' }}>{getUserFullName()}</p>
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            <span style={{ color: '#626E82' }}>CPF</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 0 }}>{userData?.user?.identification_number || 'CPF não informado'}</p>
                        </p>
                    </Col>
                    <Col span={4}>
                        <p>
                            <span style={{ color: '#626E82' }}>Telefone</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold' }}>{userData?.user?.phone ? Utils.formatNumber(userData?.user?.phone) : 'Telefone não informado'}</p>
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            <span style={{ color: '#626E82' }}>E-mail</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 0 }}>{userData?.user?.email || 'E-mail não informado'}</p>
                        </p>
                    </Col>
                </Row>
            </CardContent>
        </CardContainer>
    )

    const renderPicture = () => {
        if (userData?.user.picture) {
            return (
                <img
                    src={userData.user.picture}
                    style={{
                        objectFit: "cover",
                        borderRadius: "24px",
                        margin: "auto",
                        width: 77,
                        height: 77
                    }}
                    alt="Imagem do usuário"/>
            )
        } else {
            return (
                <span style={{
                    fontSize: 52,
                    bottom: 5,
                    position: "relative"
                }}>
                    <UserIcon/>
                </span>
            )
        }
    };

    const getUserFullName = () => {
        if(userData?.user?.first_name) {
            return userData.user.first_name + ' ' + userData.user.last_name;
        } else {
            return 'Nome não informado';
        }
    }
    
    const renderProfile = () => (
        <CardContainer style={{ minWidth: 450 }}>
            <CardTitle>
                <b><p style={{ fontSize: 18 }}>Perfil</p></b>
            </CardTitle>
            <CardContent>
                <Row align={"middle"} wrap={false}>
                    <Col span={6}>
                        <p>
                            <span style={{ color: '#626E82' }}>Cargo</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold' }}>{userData?.profile?.office || 'Cargo não informado'}</p>
                        </p>
                    </Col>
                    <Col span={6}>
                        <p>
                            <span style={{ color: '#626E82' }}>Setor</span><br />
                            <p style={{ fontSize: 16, fontWeight: 'bold' }}>{userData?.profile?.department || 'Setor não informado'}</p>
                        </p>
                    </Col>
                </Row>
            </CardContent>


        </CardContainer>
    )

    const renderPermissions = () => (
        <CardContainer style={{ minWidth: 450 }}>
            <CardTitle>
                <b><p style={{fontSize: 18, marginBottom:0}}>Permissões</p></b>
                <span style={{color: '#626E82'}}>Clique para adicionar ou retirar a permissão de cada aplicação.</span>
            </CardTitle>
            <CardContent error={errorRoleSelect ? true : false}>
            {roleData.map((data, key) => { 
                return (
                    <>
                        <span style={{color: '#626E82'}}>{ data.title }</span><br />
                        <AccountToggle data={data} key={key} onChange={(value) => handleOnChangeCheckedValue(value)}></AccountToggle>
                        <br/>
                    </>
                ) 
            })}
            </CardContent>
            {errorRoleSelect && <ErrorText>{errorRoleSelect}</ErrorText>}
        </CardContainer>
    )

    const handleOnChangeCheckedValue = (input) => {
        setErrorRoleSelect("")
        let application_id = input.target.id.split('-')[0];
        let role_id = input.target.id.split('-')[1];
        console.log(input)
        changeUserRole(application_id, role_id, input.target.checked,input);
    }

    const changeUserRole = (application_id, role_id, active, event) => {
        const body = {
            "partner_id": selectedPartner.partner_id,
            "application_id": parseInt(application_id),
            "role_id": parseInt(role_id),
            "user_id": selectedUser.id,
            "active": active,
            "access_management": true
        };

        newRoleDataCustom(application_id, role_id, active)

        Http.put("/roles/update-role-user", body)
            .catch(err => {
                newRoleDataCustom(application_id, role_id, !active)
                if (err.response?.status == 403) {
                    newRoleDataCustom(application_id, role_id, !active)
                    setErrorRoleSelect("Pelo menos uma opção deve estar selecionada")

                    return;
                }

                if (err.response?.status == 500 && err.response?.data?.response?.error == true) {
                    Message.showError(err.response.data.response.message, err);

                    return;
                }

                Message.showError("Erro ao alterar permissões. Por favor, recarregue a página.", err);
            });
    }

    const renderDevices = () => (
        <CardContainer style={{ minWidth: 450 }}>
            <CardTitle>
                <b><p style={{ fontSize: 18, marginBottom: 0 }}>Usuários do SANKHYA OM</p></b>
                <span style={{ color: '#626E82' }}>O vínculo é feito quando o usuário faz o primeiro login no SANKHYA OM.</span>
            </CardTitle>
            <CardContent>
                {userData.devices.map((device, key) => {
                    return (
                        <CardContainer style={{ padding: 2, verticalAlign: 'middle' }}>
                            <Row type="flex" align="middle">
                                <Col span={1} style={{ minWidth: 36, marginLeft: 12 }}>
                                    <ButtonBack>
                                        <AvatarIcon />
                                    </ButtonBack>
                                </Col>
                                <Col span={3} style={{ marginRight: 48 }}>
                                    <p style={{ marginBottom: 0 }}>
                                        <strong>Código</strong><br />
                                        <span>{device.code || 'Código não informado'}</span>
                                    </p>
                                </Col>
                                <Col span={3} style={{ marginRight: 48 }}>
                                    <p style={{ marginBottom: 0 }}>
                                        <strong>Usuário</strong><br />
                                        <span>{device.user || 'Usuário não informado'}</span>
                                    </p>
                                </Col>
                                <Col span={3} style={{ marginRight: 48 }}>
                                    <p style={{ marginBottom: 0 }}>
                                        <strong>Ambiente</strong><br />
                                        <span>{device.environment || 'Ambiente não informado'}</span>
                                    </p>
                                </Col>
                            </Row>
                        </CardContainer>
                    )
                })}
            </CardContent>
        </CardContainer>
    )

    return (
        <> 
           {loading ? renderLoading() : renderPage()}
        </>
    );
}

export default CardUser;